import React, { useState, useEffect, useCallback } from "react";
import Footer from "./common/Footer";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import SalesHeader from "./common/SalesHeader";
import AMHeader from "./common/AMHeader";
import RMHeader from "./common/RMHeader";
import PRDHeader from "./common/PRDHeader";
import Barchart from "./charts/Barchart";
import DonutChart from "./charts/DonutChart";
import Influencer from "./charts/Influencer";
import axios from "axios";
import * as Constants from "../Constants/index";
import swal from "sweetalert";
import Oval from "./loader/CircleLoade";
import { Formik, Form, Field, ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";
import { saveAs } from "file-saver";
import ResponsivePagination from "react-responsive-pagination";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import _, { set } from "lodash";
import DatePicker from "react-datepicker";
import { InputGroup } from "react-bootstrap";

export default function Dashboard() {
  const [isVisible, setIsVisible] = useState(false);
  const [dashboard, setDashboard] = useState({});
  const [productData, setProductData] = useState([]);
  const [points, setPoints] = useState([]);
  const [articles, setArticles] = useState([]);
  const [productQrStatus, setProductQrStatus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [articleItems, setArticleItems] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [articleoptions, setArticleOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [articleErr, setArticleErr] = useState(false);
  const [searchSapData, setSearchSapData] = useState("");
  const [userNames, setUserNames] = useState("");

  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState("10");
  let token = localStorage.getItem("token");
  const [downloadingId, setDownloadingId] = useState(null);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [now, setNow] = useState(new Date());
  const [appliedQrFilters, setAppliedQrFilters] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, 60000); // 60000ms = 1 minute

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const resetSearch = () => {
    searchFormik.resetForm({
      values: {
        startDate: null,
        endDate: null,
        sapCode: "",
      },
    });

    setAppliedQrFilters({});
    getProductQrStatusData(1, {});
    setCurrentPage(1);
    // 🔥 force-clear validation state
    searchFormik.setErrors({});
    searchFormik.setTouched({});
    searchFormik.setSubmitting(false);

    // reload list without filters
  };

  const handleScroll = () => {
    // const scrollTop = window.pageYOffset;
    // if (scrollTop > 200) {
    //     setIsVisible(true);
    // } else {
    //     setIsVisible(false);
    // }
  };
  const scrollToTop = () => {
    // window.scrollTo({
    //     top: 0,
    //     behavior: 'smooth',
    // });
  };

  const [apiCallsMade, setApiCallsMade] = useState(false);

  const searchValidationSchema = Yup.object().shape({
    sapCode: Yup.string().nullable(),
    startDate: Yup.date()
      .nullable()
      .when("endDate", {
        is: (val) => val != null,
        then: (schema) => schema.required("From date is required when To date is selected"),
        otherwise: (schema) => schema.notRequired(),
      }),
    endDate: Yup.date()
      .nullable()
      .when("startDate", {
        is: (val) => val != null,
        then: (schema) =>
          schema
            .required("To date is required when From date is selected")
            .min(Yup.ref("startDate"), "To date cannot be before From date"),
        otherwise: (schema) => schema.notRequired(),
      }),
  }, [["startDate", "endDate"]]); // Pass as pairs to avoid circular dependency

  const getProductQrStatusData = async (pageNum, filters = {}) => {
    setLoading(true);

    const { startDate, endDate, sapCode } = filters;

    const formatDateTimeYYYYMMDD = (date, isEnd = false) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const time = isEnd ? "23:59:59" : "00:00:00";
      return `${year}-${month}-${day} ${time}`;
    };

    let queryParams = "";

    if (startDate) {
      queryParams += `&start=${formatDateTimeYYYYMMDD(startDate)}`;
    }

    if (endDate) {
      queryParams += `&end=${formatDateTimeYYYYMMDD(endDate, true)}`;
    }

    if (sapCode) {
      queryParams += `&sapCode=${sapCode}`;
    }

    try {
      const res = await axios.get(
        `${Constants.baseUrl}program/child/productQrStatusByUserId?userId=${localStorage.getItem(
          "user_id",
        )}&sortBy=createdDateTime&sortAsc=false&limit=${limit}&page=${pageNum}${queryParams}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            program: Constants.program,
            company: Constants.company,
          },
        },
      );

      if (res.data.result === "success") {
        setProductQrStatus(res.data.output.results);
        setTotalPages(res.data.output.totalPages);
      } else {
        setProductQrStatus([]);
        setTotalPages(0);
      }
    } catch (err) {
      setProductQrStatus([]);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- FIXED useEffect ---------------- */
  useEffect(() => {
    const userName = localStorage.getItem("user_name");
    setUserNames(userName);

    if (!apiCallsMade && token) {
      setLoading(true);

      Promise.all([
        axios.get(Constants.baseUrl + `program/dashboard/sales`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            platform: Constants.pt,
            appVersion: Constants.av,
            program: Constants.program,
          },
        }),
        axios.post(
          Constants.baseUrl + `capture/qr/product_report_trend`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              program: Constants.program,
              company: Constants.company,
            },
          },
        ),
        axios.get(Constants.baseUrl + `user/points_report`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
          },
        }),
      ]).then(([salesRes, productTrendRes, pointsRes]) => {
        setLoading(false);

        if (
          salesRes.status === 201 &&
          productTrendRes.status === 201 &&
          pointsRes.status === 200
        ) {
          setDashboard(salesRes.data.output);
          setProductData(productTrendRes.data.output);
          setPoints(pointsRes.data.output);
          setApiCallsMade(true);
        }
      });

      // Initial load (no date filter)
      getProductQrStatusData(1);
    }
  }, [apiCallsMade]);

  const isSearchFormFieldValid = (name) =>
    !!(searchFormik.touched[name] && searchFormik.errors[name]);
  const getSearchFormErrorMessage = (name) => {
    return (
      isSearchFormFieldValid(name) && (
        <small className="report-error-field">
          {searchFormik.errors[name]}
        </small>
      )
    );
  };

  // const getProductQrStatusData = async (pageNum) => {
  //   setLoading(false);
  //   await axios
  //     .get(
  //       Constants.baseUrl +
  //       `program/child/productQrStatusByUserId?userId=${localStorage.getItem(
  //         "user_id",
  //       )}&sortBy=createdDateTime&sortAsc=false&&limit=${limit}&page=${pageNum}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Accept-Language": localStorage.getItem("langauge"),
  //           appVersion: Constants.av,
  //           platform: Constants.pt,
  //           program: Constants.program,
  //           company: Constants.company,
  //         },
  //       },
  //     )
  //     .then((res) => {
  //       const dt = res.data;
  //       if (dt.result === "success") {
  //         setProductQrStatus(dt?.output?.results);
  //         setTotalPages(dt?.output?.totalPages);
  //       }
  //       if (dt.result === "error" || dt.result === "dialog") {
  //         setProductQrStatus(null);
  //         setTotalPages(0);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //     });
  // };

  // const validationSchema = Yup.object().shape({
  //   Plant: Yup.string().required("Plant is required"),
  //   //Article: Yup.string().required("Article is required"),
  //   Codes: Yup.number()
  //     .required("No of Codes is required")
  //     .positive()
  //     .integer(),
  // });

  const validationSchema = Yup.object().shape({
    Plant:
      userNames === "Plant Administrator"
        ? Yup.string().required("Plant is required")
        : Yup.string().notRequired(),
    Codes: Yup.number()
      .required("No of Codes is required")
      .positive()
      .integer(),
  });

  const handlePrintCoupons = () => {
    let token = localStorage.getItem("token");
    if (token) {
      if (
        localStorage.getItem("requestId") > 0 &&
        localStorage.getItem("programProductId") > 0 &&
        localStorage.getItem("sapCode") != ""
      ) {
        try {
          setLoading(true);
          axios
            .post(
              Constants.baseUrl + `program/child/download/programProductQr`,
              {
                requestId: localStorage.getItem("requestId"),
                programProductId: localStorage.getItem("programProductId"),
                sapCode: localStorage.getItem("sapCode"),
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Accept-Language": localStorage.getItem("langauge"),
                  appVersion: Constants.av,
                  platform: Constants.pt,
                  program: Constants.program,
                  company: Constants.company,
                },
                responseType: "blob",
              },
            )
            .then((res) => {
              if (res.status === 201) {
                if (res.data) {
                  const fileData = new Blob([res.data], { type: "text/pdf" });
                  saveAs(fileData, "programProductQR.pdf");
                  axios
                    .get(
                      Constants.baseUrl +
                      `program/child/productQrStatusByUserId?userId=${localStorage.getItem(
                        "user_id",
                      )}&sortBy=createdDateTime&sortAsc=false&limit=10&page=1`,
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                          "Accept-Language": localStorage.getItem("langauge"),
                          appVersion: Constants.av,
                          platform: Constants.pt,
                          program: Constants.program,
                          company: Constants.company,
                        },
                      },
                    )
                    .then((res) => {
                      setProductQrStatus(res.data.output.results);
                    });
                  // swal({
                  //   text: res.data.msg,
                  //   timer: 2000,
                  //   buttons: false,
                  // });

                  localStorage.removeItem("requestId");
                  localStorage.removeItem("programProductId");
                  localStorage.removeItem("sapCode");
                } else if (res.data.code === 16001) {
                  swal({
                    text: res.data.msg,
                    timer: 2000,
                    buttons: false,
                  });
                } else {
                  swal({
                    text: res.data.msg,
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                  });
                }
                setLoading(false);
              }
            });
        } catch (error) {
          console.log(error);
        }
      } else {
        swal({
          text: "Please generate coupon and then print.",
          icon: "error",
          timer: 3000,
          buttons: false,
        });
      }
    }
  };

  const handlePrintCouponsOnlist = (requestId, programProductId, sapCode) => {
    let token = localStorage.getItem("token");
    if (token) {
      try {
        setLoading(true);
        axios
          .post(
            Constants.baseUrl + `program/child/downloadPdf/programProductQr`,
            {
              requestId: requestId,
              programProductId: programProductId,
              sapCode: sapCode,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Accept-Language": localStorage.getItem("langauge"),
                appVersion: Constants.av,
                platform: Constants.pt,
                program: Constants.program,
                company: Constants.company,
              },
              responseType: "blob",
            },
          )
          .then((res) => {
            if (res.status === 200) {
              if (res.data) {
                const fileData = new Blob([res.data], { type: "text/pdf" });
                saveAs(fileData, "programProductQR.pdf");
                axios
                  .get(
                    Constants.baseUrl +
                    `program/child/productQrStatusByUserId?userId=${localStorage.getItem(
                      "user_id",
                    )}&sortBy=createdDateTime&sortAsc=false&limit=10&page=1`,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Accept-Language": localStorage.getItem("langauge"),
                        appVersion: Constants.av,
                        platform: Constants.pt,
                        program: Constants.program,
                        company: Constants.company,
                      },
                    },
                  )
                  .then((res) => {
                    setProductQrStatus(res.data.output.results);
                  });
              } else if (res.data.code === 16001) {
                swal({
                  text: res.data.msg,
                  timer: 2000,
                  buttons: false,
                });
              } else {
                swal({
                  text: res.data.msg,
                  icon: "error",
                  timer: 3000,
                  buttons: false,
                });
              }
              setLoading(false);
            }
          });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handlePrintCouponsOnlistData = (
    requestId,
    programProductId,
    sapCode,
  ) => {
    let token = localStorage.getItem("token");
    if (token) {
      try {
        setLoading(true);
        setDownloadingId(requestId);
        axios
          .post(
            Constants.baseUrl + `program/child/downloadPdf/programProductQr`,
            {
              requestId: requestId,
              programProductId: programProductId,
              sapCode: sapCode,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Accept-Language": localStorage.getItem("langauge"),
                appVersion: Constants.av,
                platform: Constants.pt,
                program: Constants.program,
                company: Constants.company,
              },
              responseType: "blob",
            },
          )
          .then((res) => {
            if (res.status === 200) {
              if (res.data) {
                // const fileData = new Blob([res.data], { type: "text/pdf" });
                // saveAs(fileData, "programProductQR.pdf");

                // Create a URL for the PDF blob
                const pdfUrl = URL.createObjectURL(
                  new Blob([res.data], { type: "application/pdf" }),
                );

                // Create an iframe to load the PDF and trigger the print dialog
                const iframe = document.createElement("iframe");
                iframe.style.display = "none";
                iframe.src = pdfUrl;
                document.body.appendChild(iframe);

                iframe.onload = () => {
                  iframe.contentWindow.print();
                };

                setTimeout(() => {
                  getProductQrStatusData(1);
                }, 2000);

                // axios
                //   .get(
                //     Constants.baseUrl +
                //       `program/child/productQrStatusByUserId?userId=${localStorage.getItem(
                //         "user_id"
                //       )}&sortBy=createdDateTime&sortAsc=false&limit=10&page=1`,
                //     {
                //       headers: {
                //         Authorization: `Bearer ${token}`,
                //         "Accept-Language": localStorage.getItem("langauge"),
                //         appVersion: Constants.av,
                //         platform: Constants.pt,
                //         program: Constants.program,
                //         company: Constants.company,
                //       },
                //     }
                //   )
                //   .then((res) => {
                //     setProductQrStatus(res.data.output.results);
                //   });
              } else if (res.data.code === 16001) {
                swal({
                  text: res.data.msg,
                  timer: 2000,
                  buttons: false,
                });
              } else {
                swal({
                  text: res.data.msg,
                  icon: "error",
                  timer: 3000,
                  buttons: false,
                });
              }
              setLoading(false);
            }
          });
      } catch (error) {
        console.log(error);
        setDownloadingId(null);
      }
    }
  };

  let headerComponent;

  if (localStorage.getItem("user_type") === "SALES") {
    headerComponent = <SalesHeader />;
  } else if (localStorage.getItem("user_type") === "SH") {
    headerComponent = <AMHeader />;
  } else if (
    localStorage.getItem("user_type") === "RO" ||
    localStorage.getItem("user_type") === "HO" ||
    localStorage.getItem("user_type") === "ADMIN"
  ) {
    headerComponent = <RMHeader />;
  } else if (
    localStorage.getItem("user_type") === "PRD" ||
    localStorage.getItem("user_type") === "PRD-ASSOCIATE"
  ) {
    headerComponent = <PRDHeader />;
  } else if (localStorage.getItem("user_type") === "PRD-ADMIN") {
    headerComponent = <PRDHeader />;
  }

  const searchSapDataApi = async (query) => {
    if (query.length >= 2) {
      const searchData = `&name=${query}`;
      setLoading(true);
      try {
        const res = await axios.get(
          `${Constants.baseUrl}program/child/product?sortBy=name&sortAsc=true&limit=50&page=1${searchData}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("language"),
              appVersion: Constants.av,
              platform: Constants.pt,
              program: Constants.program,
              company: Constants.company,
            },
          },
        );
        setLoading(false);
        if (res.data.code === 10001) {
          const updatedItems = res.data.output.results.map((item) => ({
            id: `${item.id}_${item.sapCode}`, // Adjusted to match your API response
            name: item.sapCode,
          }));
          console.log("API Response:", updatedItems);
          setArticleItems(updatedItems);
        } else {
          console.error(res.data.msg);
          setArticleItems([]);
          setSelectedArticle("");
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
        setArticleItems([]);
        setSelectedArticle("");
      }
    } else {
      setArticleItems([]);
      setSelectedArticle("");
    }
  };

  const debounceSearch = useCallback(
    _.debounce((query) => {
      searchSapDataApi(query);
    }, 500),
    [],
  );

  const handleOnSearch = (string) => {
    setSearchSapData(string);
    debounceSearch(string);
  };

  const handleOnKeyUp = (event) => {
    if (event.target.value.length >= 2) {
      handleOnSearch(event.target.value);
    }
  };

  const handleOnClick = (event) => {
    if (event.target.value.length >= 2) {
      handleOnSearch(event.target.value);
    }
  };

  const handleOnHover = (result) => {
    // Handle hover if needed
  };

  const handleOnSelect = (item) => {
    setSelectedArticle(item.id);
    // Handle selection if needed
  };

  const formatResult = (item) => {
    console.log("Formatted Item:", item);
    return (
      <div className="result-item">
        <span>{item.name}</span>
      </div>
    );
  };

  const formatToIndianNumber = (num) => {
    // Convert string to number if needed
    const number = Number(num);

    // Check if num is a valid number
    if (isNaN(number)) return num;

    const [integerPart, decimalPart] = number.toFixed(2).split(".");
    const lastThreeDigits = integerPart.slice(-3);
    const otherDigits = integerPart.slice(0, -3);
    const formattedOtherDigits = otherDigits.replace(
      /\B(?=(\d{2})+(?!\d))/g,
      ",",
    );
    return `${otherDigits ? formattedOtherDigits + "," : ""
      }${lastThreeDigits}.${decimalPart}`;
  };

  const download = () => {
    const formatDateTimeYYYYMMDD = (date, isEnd = false) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const time = isEnd ? "23:59:59" : "00:00:00";
      return `${year}-${month}-${day} ${time}`;
    };

    setLoading(true);
    setDownloadLoading(true);

    try {
      const { startDate, endDate, sapCode } = searchFormik.values;

      let params = [];

      if (startDate) {
        params.push(
          `start=${encodeURIComponent(formatDateTimeYYYYMMDD(startDate))}`,
        );
      }

      if (endDate) {
        params.push(
          `end=${encodeURIComponent(formatDateTimeYYYYMMDD(endDate, true))}`,
        );
      }

      if (sapCode) {
        params.push(`sapCode=${encodeURIComponent(sapCode)}`);
      }

      const queryString = params.length ? `?${params.join("&")}` : "";

      axios
        .get(
          Constants.baseUrl +
          `program/child/download/productQrStatusByUserId${queryString}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program,
            },
            responseType: "blob",
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const fileData = new Blob([res.data], { type: "text/csv" });
            saveAs(fileData, "Ticket_reports.csv");
          } else {
            swal({
              text: res.data.msg,
              timer: 2000,
              buttons: false,
            });
          }

          setLoading(false);
          setDownloadLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
      setDownloadLoading(false);
    }
  };

  const searchFormik = useFormik({
    initialValues: {
      startDate: null,
      endDate: null,
      sapCode: "",
    },
    validationSchema: Yup.object().shape({
      sapCode: Yup.string().nullable(),
      startDate: Yup.date()
        .nullable()
        .when("endDate", {
          is: (val) => val != null,
          then: (schema) => schema.required("From date is required"),
          otherwise: (schema) => schema.notRequired(),
        }),
      endDate: Yup.date()
        .nullable()
        .when("startDate", {
          is: (val) => val != null,
          then: (schema) =>
            schema
              .required("To date is required")
              .min(Yup.ref("startDate"), "To date cannot be before From date"),
          otherwise: (schema) => schema.notRequired(),
        }),
    }, [["startDate", "endDate"]]), // Required to avoid circular dependency
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      setCurrentPage(1);
      setAppliedQrFilters(values);
      getProductQrStatusData(1, values);
    },
  });

  const isButtonExpired = (createdDateTime) => {
    if (!createdDateTime) return true;

    // Split your format "13-02-2026 14:31"
    const [datePart, timePart] = createdDateTime.split(" ");
    const [day, month, year] = datePart.split("-");
    const [hours, minutes] = timePart.split(":");

    // Manual Date creation (Month is 0-indexed)
    const createdDate = new Date(year, month - 1, day, hours, minutes);

    // Compare against the 'now' state
    const diffInMins = (now - createdDate) / (1000 * 60);

    return diffInMins > 5;
  };

  return (
    <>
      {loading ? <Oval /> : null}
      {headerComponent}
      <section className="blog-area pt182">
        <div className="container-fluid">
          <div className="row">
            {localStorage.getItem("user_type") === "PRD" ||
              localStorage.getItem("user_type") === "PRD-ADMIN" ||
              localStorage.getItem("user_type") === "PRD-ASSOCIATE" ? (
              <>
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="all-single-blog">
                    <div className="well">
                      <Formik
                        initialValues={{
                          Plant: "",
                          //Article: "",
                          Codes: "",
                        }}
                        validationSchema={validationSchema}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                          // Handle form submission with API call
                          // Replace this with your API call logic

                          let token = localStorage.getItem("token");
                          const user_name_data =
                            localStorage.getItem("user_name");
                          if (token) {
                            // const [programProductId, sapCode] =
                            //   values.Article.split("_");

                            const [programProductId, sapCode] =
                              selectedArticle.split("_");
                            if (programProductId > 0 && sapCode != "") {
                              setArticleErr(false);
                              try {
                                setLoading(true);
                                axios
                                  .post(
                                    Constants.baseUrl +
                                    `program/child/programProductQr/generate`,
                                    {
                                      plant:
                                        userNames !== "Plant Administrator"
                                          ? user_name_data
                                          : values.Plant,
                                      programProductId: programProductId,
                                      sapCode: sapCode,
                                      numberOfProgramProductQRCodes:
                                        values.Codes,
                                    },
                                    {
                                      headers: {
                                        Authorization: `Bearer ${token}`,
                                        "Accept-Language":
                                          localStorage.getItem("langauge"),
                                        appVersion: Constants.av,
                                        platform: Constants.pt,
                                        program: Constants.program,
                                        company: Constants.company,
                                      },
                                    },
                                  )
                                  .then((res) => {
                                    if (res.status === 201) {
                                      if (res.data.code === 10001) {
                                        localStorage.setItem(
                                          "requestId",
                                          res.data.output.requestId,
                                        );
                                        localStorage.setItem(
                                          "programProductId",
                                          res.data.output.programProductId,
                                        );
                                        localStorage.setItem(
                                          "sapCode",
                                          res.data.output.sapCode,
                                        );
                                        setArticleItems([]);
                                        setSelectedArticle("");
                                        swal({
                                          text: res.data.msg,
                                          timer: 2000,
                                          buttons: false,
                                        });
                                        resetForm();

                                        axios
                                          .get(
                                            Constants.baseUrl +
                                            `program/child/productQrStatusByUserId?userId=${localStorage.getItem(
                                              "user_id",
                                            )}&sortBy=createdDateTime&sortAsc=false&limit=10&page=1`,
                                            {
                                              headers: {
                                                Authorization: `Bearer ${token}`,
                                                "Accept-Language":
                                                  localStorage.getItem(
                                                    "langauge",
                                                  ),
                                                appVersion: Constants.av,
                                                platform: Constants.pt,
                                                program: Constants.program,
                                                company: Constants.company,
                                              },
                                            },
                                          )
                                          .then((res) => {
                                            setProductQrStatus(
                                              res.data.output.results,
                                            );
                                          });
                                      } else if (res.data.code === 16001) {
                                        swal({
                                          text: res.data.msg,
                                          timer: 2000,
                                          buttons: false,
                                        });
                                      } else {
                                        swal({
                                          text: res.data.msg,
                                          icon: "error",
                                          timer: 3000,
                                          buttons: false,
                                        });
                                      }
                                      setLoading(false);
                                    }
                                  });
                              } catch (error) {
                                console.log(error);
                              }
                            } else {
                              setArticleErr(true);
                            }
                          }
                        }}
                      >
                        {({ isSubmitting }) => (
                          <Form>
                            <div className="row">
                              {/* Plant Field */}
                              {userNames === "Plant Administrator" ? (
                                <div className="col-md-4 col-sm-4 col-xs-12">
                                  <div className="form-group">
                                    <label>Plant</label>
                                    <Field
                                      as="select"
                                      className="form-control4"
                                      id="Plant"
                                      name="Plant"
                                    >
                                      <option value="">Select</option>
                                      <option value="IN60 - Bhiwandi">
                                        IN60 - Bhiwandi
                                      </option>
                                      <option value="IN20 - Bangalore">
                                        IN20 - Bangalore
                                      </option>
                                      <option value="IN30 - Delhi">
                                        IN30 - Delhi
                                      </option>
                                      <option value="IN40 - Kolkata">
                                        IN40 - Kolkata
                                      </option>
                                    </Field>
                                    <ErrorMessage
                                      name="Plant"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                              {/* Article Field */}
                              {["PRD", "PRD-ADMIN"].includes(
                                localStorage.getItem("user_type"),
                              ) ? (
                                <></>
                              ) : (
                                <div className="col-md-3 col-sm-3 col-xs-9">
                                  <div className="form-group">
                                    <label>Select Article No.</label>

                                    <ReactSearchAutocomplete
                                      items={articleItems}
                                      onSearch={handleOnSearch}
                                      onHover={handleOnHover}
                                      onSelect={handleOnSelect}
                                      formatResult={formatResult}
                                      onKeyUp={handleOnKeyUp} // Handle key up event
                                      onClick={handleOnClick} // Handle click event
                                      autoFocus
                                      placeholder="Search for SAP Code"
                                      styling={{
                                        border: "1px solid #ccc",
                                        backgroundColor: "white",
                                        boxShadow: "none",
                                        hoverBackgroundColor: "#f0f0f0",
                                        color: "black",
                                        fontSize: "16px",
                                        iconColor: "black",
                                        lineColor: "#ccc",
                                        placeholderColor: "grey",
                                        clearIconMargin: "3px 8px 0 0",
                                        borderRadius: "0px",
                                        minHeight: "31px",
                                        zIndex: 1000,
                                        overflowY: "auto",
                                      }}
                                      showIcon={true}
                                      showClear={true}
                                      maxResults={50}
                                    />
                                    {articleErr && (
                                      <div class="text-danger">
                                        Article is required
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}

                              {/* Codes Field */}

                              {localStorage.getItem("user_type") === "PRD" ? (
                                <></>
                              ) : (
                                <div className="col-md-3 col-sm-3 col-xs-9">
                                  <div className="form-group">
                                    <label>Coupon Print Quantity</label>
                                    <Field
                                      type="text"
                                      name="Codes"
                                      id="Codes"
                                      className="form-control4"
                                    />
                                    <ErrorMessage
                                      name="Codes"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                </div>
                              )}

                              <div className="col-md-3 col-sm-3 col-xs-12">
                                <div
                                  className="one-center"
                                  style={{ position: "static", marginBottom: "16px" }}
                                >
                                  {["PRD", "PRD-ADMIN"].includes(
                                    localStorage.getItem("user_type"),
                                  ) ? (
                                    <></>
                                  ) : (
                                    <button
                                      type="submit"
                                      className="coupon-btn"
                                      style={{ position: "static", marginTop: "31px" }}
                                      // disabled={isSubmitting}
                                    >
                                      Click to Generate Coupon
                                    </button>
                                  )}
                                  {/* <button
                                    type="button"
                                    className="btn login_btn"
                                    disabled={isSubmitting}
                                    onClick={handlePrintCoupons}
                                  >
                                    DOWNLOAD COUPONS
                                  </button> */}
                                </div>
                              </div>
                              <div className="col-md-12 col-sm-12">
                                {localStorage.getItem("user_type") ===
                                  "PRD" && (
                                    <div className="mb-3">
                                      <div className="d-flex align-items-start gap-2">
                                        {/* From Date */}
                                        <div>
                                          <DatePicker
                                            selected={
                                              searchFormik.values.startDate
                                            }
                                            onChange={(date) =>
                                              searchFormik.setFieldValue(
                                                "startDate",
                                                date,
                                              )
                                            }
                                            placeholderText="From date"
                                            className="form-control"
                                            dateFormat="dd-MM-yyyy"
                                            maxDate={new Date()}
                                          />
                                          {searchFormik.submitCount > 0 &&
                                            searchFormik.errors.startDate && (
                                              <small className="text-danger">
                                                {searchFormik.errors.startDate}
                                              </small>
                                            )}
                                        </div>

                                        {/* To Date */}
                                        <div>
                                          <DatePicker
                                            selected={searchFormik.values.endDate}
                                            onChange={(date) =>
                                              searchFormik.setFieldValue(
                                                "endDate",
                                                date,
                                              )
                                            }
                                            placeholderText="To date"
                                            className="form-control"
                                            dateFormat="dd-MM-yyyy"
                                            maxDate={new Date()}
                                            minDate={
                                              searchFormik.values.startDate
                                            }
                                          />
                                          {searchFormik.submitCount > 0 &&
                                            searchFormik.errors.endDate && (
                                              <small className="text-danger">
                                                {searchFormik.errors.endDate}
                                              </small>
                                            )}
                                        </div>
                                        {/* SAP Code Filter */}
                                        <div>
                                          <input
                                            type="text"
                                            name="sapCode"
                                            placeholder="Enter Article No."
                                            className="form-control"
                                            value={searchFormik.values.sapCode}
                                            onChange={searchFormik.handleChange}
                                          />
                                        </div>

                                        {/* Buttons */}
                                        <div className="d-flex gap-2">
                                          <button
                                            type="button"
                                            className="btn login_btn"
                                            onClick={searchFormik.submitForm}
                                          >
                                            SEARCH
                                          </button>

                                          <button
                                            type="button"
                                            className="btn login_btn"
                                            onClick={resetSearch}
                                          >
                                            RESET
                                          </button>

                                          <button
                                            type="button"
                                            className="btn login_btn"
                                            onClick={download}
                                          >
                                            EXPORT
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                              </div>
                            </div>
                            {/* Submit Buttons */}
                            {/* <div className="row">
                              <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                                <div className="form-group">
                                  {localStorage.getItem("user_type") ===
                                    "PRD" ? (
                                    <></>
                                  ) : (
                                    <button
                                      type="submit"
                                      className="btn login_btn"
                                    >
                                      Click to Generate Coupon
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div> */}
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>

                <div className="col-md-12 col-sm-12 col-xs-12">
                  <h3>Product QR Status</h3>
                  <div className="table-responsive mbtable">
                    <table className="table table-border table-striped table-earning">
                      <thead>
                        <tr>
                          <th>Request ID</th>
                          <th>Plant</th>
                          <th>Product Id</th>
                          <th>Article No.</th>
                          <th>Article Name</th>
                          <th>Coupon Print Quantity</th>
                          <th>Created Date Time</th>
                          <th>User Id</th>
                          <th>User Mobile</th>
                          <th>User Name</th>
                          <th>Generated By</th>
                          <th>Print Status</th>
                          {localStorage.getItem("user_type") !== "PRD" && (
                            <th>Action</th>
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {productQrStatus &&
                          productQrStatus.length > 0 &&
                          productQrStatus.map((item, index) => (
                            <tr key={index}>
                              <td>{item.requestId}</td>
                              <td>{item.plant}</td>
                              <td>{item.programProductId}</td>
                              <td>{item.sapCode}</td>
                              <td>{item.skuDetail}</td>
                              <td>{item.couponGeneratedCount}</td>
                              <td>{item.createdDateTime}</td>
                              <td>{item.userId}</td>
                              <td>{item.mobile}</td>
                              <td>{item.userName}</td>
                              <td>{item.userType}</td>
                              <td>{item.qrDownloaded ? "YES" : "NO"}</td>

                              {localStorage.getItem("user_type") !== "PRD" && (
                                <td>
                                  {localStorage.getItem("user_type") !==
                                    "PRD" ||
                                    localStorage.getItem("user_type") !==
                                    "PRD-ASSOCIATE" ? null : (
                                    <button
                                      type="button"
                                      className="btn login_btn"
                                      onClick={() =>
                                        handlePrintCouponsOnlist(
                                          item.requestId,
                                          item.programProductId,
                                          item.sapCode,
                                        )
                                      }
                                    >
                                      DOWNLOAD
                                    </button>
                                  )}
                                  {item?.status === "DOWNLOADED" ||
                                    item?.qrDownloaded === true ||
                                    isButtonExpired(item.createdDateTime) ? (
                                    <button
                                      type="button"
                                      disabled
                                      style={{
                                        backgroundColor: "grey",
                                        color: "white",
                                        cursor: "not-allowed",
                                        marginLeft: "5px",
                                      }}
                                      className="btn"
                                    >
                                      PRINT
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn login_btn"
                                      style={{
                                        backgroundColor:
                                          downloadingId === item.requestId ? "green" : "red",
                                        color: "white",
                                        marginLeft: "5px",
                                      }}
                                      onClick={() =>
                                        handlePrintCouponsOnlistData(
                                          item.requestId,
                                          item.programProductId,
                                          item.sapCode
                                        )
                                      }
                                    >
                                      PRINT
                                    </button>
                                  )}
                                </td>
                              )}
                            </tr>
                          ))}
                      </tbody>
                    </table>

                    {totalPages > 1 && (
                      <ResponsivePagination
                        current={currentPage}
                        total={totalPages}
                        onPageChange={(page) => {
                          setCurrentPage(page);
                          getProductQrStatusData(page, appliedQrFilters);
                        }}
                      />
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="all-single-blog">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="heading-banner-title">
                          <h4>Performance summary Influencers</h4>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3 col30 col-xs-12">
                        <div className="info-box_1 nf1 wd80">
                          <div
                            className="info-box-content"
                            style={{ paddingLeft: "8px", paddingRight: "8px" }}
                          >
                            <span className="info-box-text  bold text-center">
                              Influencers Performance
                            </span>
                            <span className="info-box-text">
                              Total Onboarded Influencers{" "}
                              <span className="bold">{dashboard?.members}</span>
                            </span>
                            <span className="info-box-number">
                              Total Approved Influencers{" "}
                              <span className="bold">
                                {dashboard?.memberApproved}
                              </span>
                            </span>
                            <span className="info-box-number">
                              Total Active Influencers{" "}
                              <span className="bold">
                                {dashboard?.memberActive}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col40 col-xs-12">
                        <div className="info-box_1 nf3 wd80">
                          <div
                            className="info-box-content"
                            style={{ paddingLeft: "8px", paddingRight: "8px" }}
                          >
                            <span className="info-box-text  bold text-center">
                              Product Reporting Trend
                            </span>
                            <div
                              style={{
                                height: "100px",
                                overflowY: "auto",
                                scrollbarWidth: "thin",
                              }}
                            >
                              <table
                                className="no-border table-borderless"
                                style={{ width: "100%" }}
                              >
                                <thead>
                                  <tr>
                                    <th>Product Category</th>
                                    <th className="text-center">
                                      No. Of Scans
                                    </th>
                                    <th className="text-center">
                                      Total Sales in INR
                                    </th>
                                    <th className="text-right">
                                      Points Awarded
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {productData.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item.category}</td>
                                      <td className="text-center">
                                        {item.total_scan}
                                      </td>
                                      <td className="text-center">
                                        {formatToIndianNumber(
                                          item?.total_price,
                                        )}
                                      </td>
                                      <td className="text-right">
                                        {item.point_award}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 col30 col-xs-12">
                        <div className="info-box_1 nf2 wd80">
                          <div
                            className="info-box-content"
                            style={{ paddingLeft: "8px", paddingRight: "8px" }}
                          >
                            <span className="info-box-text  bold text-center">
                              Points Reporting Trend
                            </span>
                            <span className="info-box-text">
                              Total Scanned{" "}
                              <span id="pntscan" className="bold">
                                {dashboard?.scanTotal}
                              </span>
                            </span>
                            <span className="info-box-text">
                              Total Balance{" "}
                              <span id="pntblnc" className="bold">
                                {dashboard?.totalPointsBalance}
                              </span>
                            </span>
                            <span className="info-box-text">
                              Total Redeemed{" "}
                              <span id="pntredeem" className="bold">
                                {dashboard?.pointsRedeemed}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <Influencer />
                      <DonutChart />
                      <Barchart />
                    </div>
                    <br />
                    <div className="row mt-15">
                      {/* login  */}
                      <div className="col-md-3">
                        <div className="info-box_1 nflink wd80">
                          <Link to="/rpt_login">
                            <div className="info-box-content">
                              <span className="info-box-text">
                                Login Report
                              </span>
                            </div>
                          </Link>
                        </div>
                      </div>

                      {/* Enrollment */}
                      <div className="col-md-3">
                        <div className="info-box_1 nflink wd80">
                          <Link to="/rpt_enrollment">
                            <div className="info-box-content">
                              <span className="info-box-text">
                                Enrollment Report{" "}
                              </span>
                            </div>
                          </Link>
                        </div>
                      </div>

                      {/* Anomaly */}
                      <div className="col-md-3">
                        <div className="info-box_1 nflink wd80">
                          <Link to="/rpt_anomaly">
                            <div className="info-box-content">
                              <span className="info-box-text">
                                Anomaly Report
                              </span>
                            </div>
                          </Link>
                        </div>
                      </div>

                      {/* Redemption */}
                      <div className="col-md-3">
                        <div className="info-box_1 nflink wd80">
                          <Link to="/rpt_redemption">
                            <div className="info-box-content">
                              <span className="info-box-text">
                                Redemption Report
                              </span>
                            </div>
                          </Link>
                        </div>
                      </div>

                      {/* Ticket */}
                      <div className="col-md-3">
                        <div className="info-box_1 nflink wd80">
                          <Link to="/ticket_report">
                            <div className="info-box-content">
                              <span className="info-box-text">
                                Ticket Report
                              </span>
                            </div>
                          </Link>
                        </div>
                      </div>

                      {/* OTP */}
                      <div className="col-md-3">
                        <div className="info-box_1 nflink wd80">
                          <Link to="/rpt_otp_sms">
                            <div className="info-box-content">
                              <span className="info-box-text">OTP Report</span>
                            </div>
                          </Link>
                        </div>
                      </div>

                      {/* Registered Users */}
                      <div className="col-md-3">
                        <div className="info-box_1 nflink wd80">
                          <Link to="/rpt_registered_users">
                            <div className="info-box-content">
                              <span className="info-box-text">
                                Registered Users Report
                              </span>
                            </div>
                          </Link>
                        </div>
                      </div>

                      {/* QR Error Scan Transaction */}
                      {localStorage.getItem("user_mobile") !== "8860644072" ||
                        localStorage.getItem("user_mobile") !== "9350859293" ? (
                        <div className="col-md-3">
                          <div className="info-box_1 nflink wd80">
                            <Link to="/rpt_qr_error">
                              <div className="info-box-content">
                                <span className="info-box-text">
                                  QR Error Scan Transaction Report
                                </span>
                              </div>
                            </Link>
                          </div>
                        </div>
                      ) : (
                        <div className="col-md-3">
                          <div className="info-box_1 nflink wd80">
                            <div className="info-box-content">
                              <span
                                className="info-box-text"
                                style={{ color: "gray" }}
                              >
                                QR Error Scan Transaction Report
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Product Wise */}
                      {/* {localStorage.getItem("user_mobile") === "9999099548" || localStorage.getItem("user_mobile") === "9004486485" ? */}
                      <div className="col-md-3">
                        <div className="info-box_1 nflink wd80">
                          <Link to="/rpt_product_wise">
                            <div className="info-box-content">
                              <span className="info-box-text">
                                Product Wise Report
                              </span>
                            </div>
                          </Link>
                        </div>
                      </div>
                      {/* //  : 
                    // <div className="col-md-3">
                    //   <div className="info-box_1 nflink wd80">
                    //       <div className="info-box-content">
                    //         <span className="info-box-text" style={{color:"gray"}}>
                    //             Product Wise Report
                    //         </span>
                    //       </div>
                    //   </div>
                    // </div>} */}

                      {/* Warehouse Printing Data */}
                      {localStorage.getItem("user_mobile") === "9004486485" ||
                        localStorage.getItem("user_mobile") === "9999099548" ? (
                        <div className="col-md-3">
                          <div className="info-box_1 nflink wd80">
                            <Link to="/rpt_warehouse">
                              <div className="info-box-content">
                                <span className="info-box-text">
                                  Warehouse Printing Data Report
                                </span>
                              </div>
                            </Link>
                          </div>
                        </div>
                      ) : null}

                      {/* Articles */}
                      {localStorage.getItem("user_type") === "ADMIN" ||
                        localStorage.getItem("user_mobile") === "9004486485" ? (
                        <div className="col-md-3">
                          <div className="info-box_1 nflink wd80">
                            <Link to="/rpt_articles">
                              <div className="info-box-content">
                                <span className="info-box-text">
                                  Articles Report
                                </span>
                              </div>
                            </Link>
                          </div>
                        </div>
                      ) : null}

                      {/* Sales District Map */}
                      {localStorage.getItem("user_type") === "ADMIN" ||
                        localStorage.getItem("user_mobile") === "9004486485" ? (
                        <div className="col-md-3">
                          <div className="info-box_1 nflink wd80">
                            <Link to="/rpt_sales_district_map">
                              <div className="info-box-content">
                                <span className="info-box-text">
                                  Sales District Map Report
                                </span>
                              </div>
                            </Link>
                          </div>
                        </div>
                      ) : null}

                      {/* Sales Hierarchy */}
                      {localStorage.getItem("user_type") === "ADMIN" ||
                        localStorage.getItem("user_mobile") === "9004486485" ? (
                        <div className="col-md-3">
                          <div className="info-box_1 nflink wd80">
                            <Link to="/rpt_sales_hierarchy">
                              <div className="info-box-content">
                                <span className="info-box-text">
                                  Sales Hierarchy Report
                                </span>
                              </div>
                            </Link>
                          </div>
                        </div>
                      ) : null}

                      {/* Sales login report */}
                      {localStorage.getItem("user_type") === "ADMIN" ||
                        localStorage.getItem("user_type") === "HO" ? (
                        <div className="col-md-3">
                          <div className="info-box_1 nflink wd80">
                            <Link to="/sales_login_report">
                              <div className="info-box-content">
                                <span className="info-box-text">
                                  TM Login Report
                                </span>
                              </div>
                            </Link>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
      <Footer />
      <Link
        id="scrollUp"
        to=""
        className={`scroll-to-top-button ${isVisible ? "visible" : "hidden"}`}
        style={{ position: "fixed", zIndex: "2147483647" }}
        onClick={scrollToTop}
      >
        <FontAwesomeIcon icon={faChevronUp} />
      </Link>
    </>
  );
}
